module.exports = __webpack_public_path__ + "img/C9.35971a96.svg";